<script setup lang="ts">
const i18nHead = useLocaleHead({ key: 'id' });

useHead({
  htmlAttrs: {
    lang: i18nHead.value.htmlAttrs!.lang,
  },
  link: [...(i18nHead.value?.link ?? [])],
  meta: [
    { property: `og:type`, content: `website` },
    { property: `og:site_name`, content: `IAD France` },
    { name: `twitter:site`, content: `@IADFrance` },
    { name: `twitter:creator`, content: `@IADFrance` },
    { name: `twitter:card`, content: `summary` },
    { name: `robots` },
  ],
});
</script>

<template>
  <div>
    <NuxtLoadingIndicator color="#FF7F31" />
    <MainHeader />
    <IadWrapper class="markdown-content">
      <slot />
    </IadWrapper>
    <ClientOnly>
      <MainFooter />
    </ClientOnly>
  </div>
</template>

<style lang="css" scoped>
.markdown-content :deep(h1) {
  @apply text-3xl lg:text-6xl font-semibold text-center py-2xl;
}
.markdown-content :deep(h2) {
  @apply text-2xl lg:text-3xl font-semibold pt-xl pb-xs;
}
.markdown-content :deep(h3) {
  @apply text-xl lg:text-2xl pt-l pb-2xs;
}
.markdown-content :deep(h2 a),
.markdown-content :deep(h3 a) {
  @apply no-underline;
}
.markdown-content :deep(p),
.markdown-content :deep(ul),
.markdown-content :deep(ol) {
  @apply pb-m leading-normal;
}
.markdown-content :deep(a) {
  @apply underline;
}
.markdown-content :deep(table) {
  @apply mb-m;
}
.markdown-content :deep(table),
.markdown-content :deep(th),
.markdown-content :deep(td) {
  @apply border;
}
.markdown-content :deep(th),
.markdown-content :deep(td) {
  @apply px-m py-s;
}

.markdown-content :deep(ul) {
  @apply list-['-_'] pl-l;
}
.markdown-content :deep(ol) {
  @apply list-decimal pl-l;
}
</style>
